import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const role = store.getters['auth/role']
  const menu = [
    {
      menuId: 8,
      icon: 'issued',
      name: i18n.t('invoices.issued_header'),
      path: 'invoicesissued',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'invoicesissued/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('historical.entity_name'),
          path: 'invoicesissued/historical',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ]
    }
  ]
  const submenuGroups = {
    name: i18n.t('groups.groups_link'),
    path: 'invoicesissued/groups',
    params,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }
  if ([2, 7, 8, 3].includes(role)) {
    menu[0].sc.splice(1, 0, submenuGroups)
  }

  return menu
}
